(function() {
  function initCountdown(el) {
    const raw = el.getAttribute('data-drop-time');
    if (!raw) return;

    const target = new Date(raw);
    if (isNaN(target.getTime())) {
      el.textContent = "Set drop_time to ISO like 2026-01-10T18:00:00-05:00";
      return;
    }

    function fmt(ms) {
      const s = Math.floor(ms / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const ss = s % 60;
      return d + "d " + String(h).padStart(2,'0') + "h " + String(m).padStart(2,'0') + "m " + String(ss).padStart(2,'0') + "s";
    }

    function tick() {
      const now = new Date();
      const ms = target - now;
      el.textContent = ms <= 0 ? "LIVE NOW" : fmt(ms);
      if (ms > 0) setTimeout(tick, 250);
    }
    tick();
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-goe-countdown]').forEach(initCountdown);
  });
})();
